var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.b21c854ce00ee6ee1fcc4040ae854c08.svg#l';
                    var viewUrl = 'sprites.b21c854ce00ee6ee1fcc4040ae854c08.svg#view-l';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 108 128',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };